import { ShippingMethodsGroups } from '@yme/common/redux/cart/constants';
import { reqExpContainsNumbers } from '@yme/utils/regEx';
import { RANGE_SYMBOL_KEY, ANY_SYMBOL_KEY } from './constant';
const prepareAddressBlockStateObject = (fields, currentCountry = '') => {
    const { address, city, postalCode, state, country } = fields;
    const deliveryAddress = `${address} ${postalCode} ${city}`;
    return {
        deliveryAddress: deliveryAddress.trim(),
        address,
        city,
        postalCode,
        state,
        country: country || currentCountry,
    };
};
export const checkInitialStateValues = (initialStateValue) => Object.values({
    ...initialStateValue,
    country: '',
}).some((value) => value);
export const checkReqExpHouseNumber = (address) => address.search(reqExpContainsNumbers) !== -1;
export const getInitialStateForAddressBlock = (cartAddressInfo, profileAddressInfo, currentCountry) => {
    if (checkInitialStateValues(cartAddressInfo)) {
        return prepareAddressBlockStateObject(cartAddressInfo);
    }
    if (profileAddressInfo) {
        return prepareAddressBlockStateObject(profileAddressInfo, currentCountry);
    }
    return {
        deliveryAddress: '',
        address: '',
        city: '',
        postalCode: '',
        state: '',
        country: currentCountry ?? '',
    };
};
export const getClearStateValue = (value) => {
    const code = value.split('|')[0] ?? '';
    return code;
};
export const getActiveStateInfo = (states, province) => {
    const activeState = states.find((state) => state.name.toLowerCase() === province.toLowerCase());
    return activeState ? `${activeState.code}|${activeState.name}` : '';
};
export const getIsNumericCodeExclusion = (postalCode, numericCodeExclusions) => numericCodeExclusions.some((exclusion) => {
    const trimmedExclusion = exclusion.trim();
    if (trimmedExclusion.includes(RANGE_SYMBOL_KEY)) {
        const [start, end] = trimmedExclusion.split(RANGE_SYMBOL_KEY).map(Number);
        return postalCode >= start && postalCode <= end;
    }
    else {
        return postalCode === Number(trimmedExclusion);
    }
});
export const getIsAlphanumericCodeExclusion = (postalCode, alphanumericCodeExclusions) => {
    const updatedPostalCode = postalCode.replaceAll(' ', '').toLowerCase();
    return alphanumericCodeExclusions.some((exclusion) => {
        const updatedExclusion = exclusion.replaceAll(' ', '').toLowerCase();
        if (updatedExclusion.endsWith(ANY_SYMBOL_KEY) && updatedExclusion.length > 1) {
            return updatedPostalCode.startsWith(updatedExclusion.slice(0, -1));
        }
        return updatedPostalCode === updatedExclusion;
    });
};
export const getPostalCodeError = (postalCode, { postalCodeRegexp, numericCodeExclusions, alphanumericCodeExclusions }, hasExclusionValidation, t) => {
    if (!postalCode.length) {
        return t('checkout_personalDetailsRequiredField_error');
    }
    if (postalCodeRegexp && !new RegExp(postalCodeRegexp).test(postalCode)) {
        return t('common_postalCodeFormat_error');
    }
    if (hasExclusionValidation &&
        !isNaN(Number(postalCode)) &&
        numericCodeExclusions.length &&
        getIsNumericCodeExclusion(Number(postalCode.trim()), numericCodeExclusions)) {
        return t('checkout_shippingDetailsPostalCodeExclusion_error');
    }
    if (hasExclusionValidation &&
        alphanumericCodeExclusions.length &&
        getIsAlphanumericCodeExclusion(postalCode, alphanumericCodeExclusions)) {
        return t('checkout_shippingDetailsPostalCodeExclusion_error');
    }
    return '';
};
export const isHomeShipping = (value = '') => ShippingMethodsGroups.HOME.includes(value);
